export const COMMON_LAND = 'Common Land';
export const RARE_LAND = 'Rare Land';
export const EPIC_LAND = 'Epic Land';
export const LEGENDARY_LAND = 'Legendary Land';
export const MYTHICAL_LAND = 'Mythical Land';
